// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__101fD","load6":"Spinner_load6__3P-lH","round":"Spinner_round__EIwnt"};